module.exports = __webpack_public_path__ + "media/images/multicat-marker-540ce5091d43d9654cda55a432b8abf7.png";